import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetFernieCustomerCandidatesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.CustomersSummaryDocumentFilterInput>;
}>;


export type GetFernieCustomerCandidatesQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomersSummaryDocument', customerId: string, erpId: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetFernieShipToCandidatesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.CustomerLocationDocumentFilterInput>;
}>;


export type GetFernieShipToCandidatesQuery = { __typename?: 'Query', customerLocations?: { __typename?: 'CustomerLocationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomerLocationDocument', customerName: string, locationId: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetFernieItemCandidatesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.ItemSummaryDocumentFilterInput>;
}>;


export type GetFernieItemCandidatesQuery = { __typename?: 'Query', items?: { __typename?: 'ItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ItemSummaryDocument', erpId: string, itemId: string, name: string, sku: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetFernieTermsCandidatesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.TermsDocumentFilterInput>;
}>;


export type GetFernieTermsCandidatesQuery = { __typename?: 'Query', terms?: { __typename?: 'TermsConnection', totalCount: number, nodes?: Array<{ __typename?: 'TermsDocument', name: string, termsId: string, usageCount?: number | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetFerniePriceGroupCandidatesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetFerniePriceGroupCandidatesQuery = { __typename?: 'Query', priceGroups?: { __typename?: 'PriceGroupsConnection', totalCount: number, nodes?: Array<{ __typename?: 'PriceGroupDocument', name: string, priceId: string, usageCount?: number | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetFernieCustomerTypeCandidatesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetFernieCustomerTypeCandidatesQuery = { __typename?: 'Query', customerTypes?: { __typename?: 'CustomerTypesConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomerTypeDocument', customerTypeId: string, name: string, usageCount?: number | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetFernieCategoryCandidatesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetFernieCategoryCandidatesQuery = { __typename?: 'Query', categories?: { __typename?: 'CategoriesConnection', totalCount: number, nodes?: Array<{ __typename?: 'CategoryDocument', id: string, usageCount?: number | null, category: { __typename?: 'CategoryData', code: string } }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetFernieVendorCandidatesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.VendorDocumentFilterInput>;
}>;


export type GetFernieVendorCandidatesQuery = { __typename?: 'Query', vendors?: { __typename?: 'VendorsConnection', totalCount: number, nodes?: Array<{ __typename?: 'VendorDocument', name: string, vendorId: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetFernieKitCandidatesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetFernieKitCandidatesQuery = { __typename?: 'Query', kits?: { __typename?: 'KitsConnection', totalCount: number, nodes?: Array<{ __typename?: 'KitDocument', kitId: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetFernieSiteCandidatesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetFernieSiteCandidatesQuery = { __typename?: 'Query', siteLocations?: { __typename?: 'SiteLocationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'SiteLocationDocument', name: string, siteLocationId: string, status: Types.LocationStatus }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetFernieSubLocationCandidatesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetFernieSubLocationCandidatesQuery = { __typename?: 'Query', subLocations?: { __typename?: 'SubLocationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'SubLocationDocument', locationId: string, name: string, locationType: Types.SiteLocationType, parentLocationId: string, siteLocationId: string, status: Types.LocationStatus }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };


export const GetFernieCustomerCandidatesDocument = new TypedDocumentString(`
    query GetFernieCustomerCandidates($first: Int, $after: String, $where: CustomersSummaryDocumentFilterInput) {
  customers(first: $first, after: $after, where: $where) {
    totalCount
    nodes {
      customerId
      erpId
      name
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetFernieShipToCandidatesDocument = new TypedDocumentString(`
    query GetFernieShipToCandidates($first: Int, $after: String, $where: CustomerLocationDocumentFilterInput) {
  customerLocations(first: $first, after: $after, where: $where) {
    totalCount
    nodes {
      customerName
      locationId
      name
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetFernieItemCandidatesDocument = new TypedDocumentString(`
    query GetFernieItemCandidates($first: Int, $after: String, $where: ItemSummaryDocumentFilterInput) {
  items(first: $first, after: $after, where: $where) {
    totalCount
    nodes {
      erpId
      itemId
      name
      sku
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetFernieTermsCandidatesDocument = new TypedDocumentString(`
    query GetFernieTermsCandidates($first: Int, $after: String, $where: TermsDocumentFilterInput) {
  terms(first: $first, after: $after, where: $where) {
    totalCount
    nodes {
      name
      termsId
      usageCount
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetFerniePriceGroupCandidatesDocument = new TypedDocumentString(`
    query GetFerniePriceGroupCandidates($first: Int, $after: String) {
  priceGroups(first: $first, after: $after) {
    totalCount
    nodes {
      name
      priceId
      usageCount
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetFernieCustomerTypeCandidatesDocument = new TypedDocumentString(`
    query GetFernieCustomerTypeCandidates($first: Int, $after: String) {
  customerTypes(first: $first, after: $after) {
    totalCount
    nodes {
      customerTypeId
      name
      usageCount
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetFernieCategoryCandidatesDocument = new TypedDocumentString(`
    query GetFernieCategoryCandidates($first: Int, $after: String) {
  categories(first: $first, after: $after) {
    totalCount
    nodes {
      category {
        code
      }
      id
      usageCount
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetFernieVendorCandidatesDocument = new TypedDocumentString(`
    query GetFernieVendorCandidates($first: Int, $after: String, $where: VendorDocumentFilterInput) {
  vendors(first: $first, after: $after, where: $where) {
    totalCount
    nodes {
      name
      vendorId
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetFernieKitCandidatesDocument = new TypedDocumentString(`
    query GetFernieKitCandidates($first: Int, $after: String) {
  kits(first: $first, after: $after) {
    totalCount
    nodes {
      kitId
      name
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetFernieSiteCandidatesDocument = new TypedDocumentString(`
    query GetFernieSiteCandidates($first: Int, $after: String) {
  siteLocations(first: $first, after: $after) {
    totalCount
    nodes {
      name
      siteLocationId
      status
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetFernieSubLocationCandidatesDocument = new TypedDocumentString(`
    query GetFernieSubLocationCandidates($first: Int, $after: String) {
  subLocations(first: $first, after: $after) {
    totalCount
    nodes {
      locationId
      name
      locationType
      parentLocationId
      siteLocationId
      status
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetFernieCustomerCandidates: build.query<GetFernieCustomerCandidatesQuery, GetFernieCustomerCandidatesQueryVariables | void>({
      query: (variables) => ({ document: GetFernieCustomerCandidatesDocument, variables })
    }),
    GetFernieShipToCandidates: build.query<GetFernieShipToCandidatesQuery, GetFernieShipToCandidatesQueryVariables | void>({
      query: (variables) => ({ document: GetFernieShipToCandidatesDocument, variables })
    }),
    GetFernieItemCandidates: build.query<GetFernieItemCandidatesQuery, GetFernieItemCandidatesQueryVariables | void>({
      query: (variables) => ({ document: GetFernieItemCandidatesDocument, variables })
    }),
    GetFernieTermsCandidates: build.query<GetFernieTermsCandidatesQuery, GetFernieTermsCandidatesQueryVariables | void>({
      query: (variables) => ({ document: GetFernieTermsCandidatesDocument, variables })
    }),
    GetFerniePriceGroupCandidates: build.query<GetFerniePriceGroupCandidatesQuery, GetFerniePriceGroupCandidatesQueryVariables | void>({
      query: (variables) => ({ document: GetFerniePriceGroupCandidatesDocument, variables })
    }),
    GetFernieCustomerTypeCandidates: build.query<GetFernieCustomerTypeCandidatesQuery, GetFernieCustomerTypeCandidatesQueryVariables | void>({
      query: (variables) => ({ document: GetFernieCustomerTypeCandidatesDocument, variables })
    }),
    GetFernieCategoryCandidates: build.query<GetFernieCategoryCandidatesQuery, GetFernieCategoryCandidatesQueryVariables | void>({
      query: (variables) => ({ document: GetFernieCategoryCandidatesDocument, variables })
    }),
    GetFernieVendorCandidates: build.query<GetFernieVendorCandidatesQuery, GetFernieVendorCandidatesQueryVariables | void>({
      query: (variables) => ({ document: GetFernieVendorCandidatesDocument, variables })
    }),
    GetFernieKitCandidates: build.query<GetFernieKitCandidatesQuery, GetFernieKitCandidatesQueryVariables | void>({
      query: (variables) => ({ document: GetFernieKitCandidatesDocument, variables })
    }),
    GetFernieSiteCandidates: build.query<GetFernieSiteCandidatesQuery, GetFernieSiteCandidatesQueryVariables | void>({
      query: (variables) => ({ document: GetFernieSiteCandidatesDocument, variables })
    }),
    GetFernieSubLocationCandidates: build.query<GetFernieSubLocationCandidatesQuery, GetFernieSubLocationCandidatesQueryVariables | void>({
      query: (variables) => ({ document: GetFernieSubLocationCandidatesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetFernieCustomerCandidatesQuery, useLazyGetFernieCustomerCandidatesQuery, useGetFernieShipToCandidatesQuery, useLazyGetFernieShipToCandidatesQuery, useGetFernieItemCandidatesQuery, useLazyGetFernieItemCandidatesQuery, useGetFernieTermsCandidatesQuery, useLazyGetFernieTermsCandidatesQuery, useGetFerniePriceGroupCandidatesQuery, useLazyGetFerniePriceGroupCandidatesQuery, useGetFernieCustomerTypeCandidatesQuery, useLazyGetFernieCustomerTypeCandidatesQuery, useGetFernieCategoryCandidatesQuery, useLazyGetFernieCategoryCandidatesQuery, useGetFernieVendorCandidatesQuery, useLazyGetFernieVendorCandidatesQuery, useGetFernieKitCandidatesQuery, useLazyGetFernieKitCandidatesQuery, useGetFernieSiteCandidatesQuery, useLazyGetFernieSiteCandidatesQuery, useGetFernieSubLocationCandidatesQuery, useLazyGetFernieSubLocationCandidatesQuery } = injectedRtkApi;
